<!-- Mobile Header -->
<div app-home-header-mobile></div>

<!-- Header -->
<div app-home-header></div>

<!-- Content -->
<div app-home-content class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page"></div>
